"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.Content = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _stylers = _interopRequireDefault(require("@paprika/stylers"));

var Content = _styledComponents["default"].div.withConfig({
  displayName: "Contentstyles__Content",
  componentId: "sc-1i4grbm-0"
})(["padding:", ";"], _stylers["default"].spacer(3));

exports.Content = Content;
//# sourceMappingURL=Content.styles.js.map